<template>
  <item-demo v-if="isSimulation && !isMenu" :style="{ 'background-color': BGColorContent }" />
  <div 
    v-else-if="isSimulation && editTMP && id === editTMP.ID && contents" 
    :style="{ 'background-color': customBGColorContent ? customBGColorContent : BGColorContent }"
  >
    <!-- show edit content -->
    <div 
      v-for="item in contents"
      :key="`content${item.ID}`"
    >
      <items
        :item="item"
        :menuID="id"
        :isMobile="true"
        :customTextColorContent="customTextColorContent"
      />
    </div>
  </div>
  <div v-else :style="{ 'background-color': customBGColorContent ? customBGColorContent : BGColorContent }">
    <!-- load content pagination -->
      <div 
        v-for="item in apiContents"
        :key="`content${item.ID}`"
      >
        <items
          :item="item"
          :menuID="id"
          :isMobile="true"
          :customTextColorContent="customTextColorContent"
        />
      </div>
    <div ref="mark" class="text-center py-4" style="height:200px;">
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="grey"
      />
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  import constants from '@/constants'
  import Items from '@/components/Items'
  import dview from '@/services/dview-service'
  import ItemDemo from './items/Demo'
  export default {
    name: 'CustomContent',
    components: {
      Items,
      ItemDemo
    },
    props: {
      id: {
        type: String,
        required: true,
        default: null
      },
      customBGColorContent: {
        type: String,
        required: false,
        default: null
      },
      customTextColorContent: {
        type: String,
        required: false,
        default: null
      }
    },
    data: () => ({
      loading: false,
      page: 1,
      count: 0,
      itemsPerPage: 20,
      apiContents: [],
      endData: false,
      obs: null,
      attemptLimit: 30,
    }),
    computed: {
      ...mapState('app',['forceRefreshOnSave','editTMP', 'contents', 'BGColorContent', 'ColorContent']),
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isMenu () {
        return constants.menusRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      title () { return 2 },
      isTest () {
        return this.$route.query.test
      },
    },
    watch: {
      id: {
        handler (v) {
          this.init()
        },
        deep: true
      },
      'forceRefreshOnSave.lmd' () {
        if (this.forceRefreshOnSave.id === this.id) {
          this.init()
        }
      },
    },
    mounted () {
      this.initObs()
      this.getContent()
    },
    beforeDestroy() {
      if (this.obs) {
        this.obs.disconnect()
      }
    },
    methods: {
      initObs () {
        const options = {
          root: null, // Usa la pantalla completa (viewport) como referencia de scroll
          //rootMargin: '0px',  
          rootMargin: '0px 0px 150px 0px', 
          threshold: 0.1 // Se activa en cuanto asoma un 10% del div en pantalla
        };

        this.obs = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !this.loading && !this.endData) {
              this.handleNextPage()
            }
          });
        }, options)

        // Le decimos al observador que vigile nuestro div marcador
        if (this.$refs.mark) {
          this.obs.observe(this.$refs.mark);
        }
      },
      async init () {
        this.attemptLimit = 100
        this.page = 1
        this.count = 0
        this.endData = false
        this.apiContents = []
        this.getContent()
      },
      handleNextPage () {
        this.page++
        this.getContent()
      },
      async getContent() {
        try {
          this.loading = true
          this.attemptLimit--
          if (this.attemptLimit <= 0) {
            this.endData = true
            return
          }
          //api.getAll(`contents`, false, null, null, null, id).then(response => {
          //const aux = await new Promise((resolve, reject) => api.getAll(`contents`, false, this.page, this.itemPerPage, null, this.id.concat(this.isTest ? '/test': ''))
          const body = {
            page: this.page,
            itemsPerPage: this.itemsPerPage
          }
          const aux = await new Promise((resolve, reject) => api.put(`contents`, false, this.id.concat(this.isTest ? '/test': ''), body)
          .then(response => {
              if (!response || !response.data) {
                this.endData = true
                return
              }
            resolve(response.data.map(item => {
              item.IsActive = dview.isActive(item)
              return (item)
            }).filter(x => x.IsActive.date && x.IsActive.time || this.isSimulation))

            // console.log('hhh', response.filter( x => dview.isActive(x).time).length)
            // this.apiContents = response
            this.loading = false
          })
          .catch (error => {
            reject(error)
          })
          .finally(() => {
            this.loading = false
          }))
          if (!aux) this.endData = true
          else {
            this.apiContents.push(...aux)
          }

           this.$nextTick(() => {
            if (this.$refs.mark) {
              const rect = this.$refs.mark.getBoundingClientRect()
              const isVisible = rect.top < window.innerHeight

              // Si sigue visible en la pantalla del usuario, llamamos otra vez a la API inmediatamente
              if (isVisible && !this.endData) {
                this.handleNextPage()
              }
            }
          })
          this.loading = false
        } catch (error) {
          console.log('error', error)
          this.loading = false
        }
      }
    }
  }
</script>
<style scoped>
</style>
